/**
 * Derives the in-app navigation target for an application-menu hash link by
 * stripping the leading `#`, e.g. `#/team/staff-clocks` -> `/team/staff-clocks`.
 * This is the FULL landing path the link points at (matching the AngularJS
 * topbar's `ng-href="{{link.link}}"`), and the value `LoadedLink` expects in its
 * `to` prop (it rebuilds the `#` itself). A path with no leading `#` (e.g. a
 * router pathname) is returned unchanged.
 */
export function getModuleNavTarget(link: string): string {
  return link.replace(/^#/, '')
}

/**
 * Extracts the first path segment of a route path, e.g. for `/team/staff-clocks`
 * (a router pathname) or `#/team/staff-clocks` (a module hash link) this returns
 * `/team`. The optional leading `#` is stripped first so the router's `pathname`
 * and the application menu's hash links reduce to the same comparison unit.
 *
 * Returns an empty string when there is no usable segment - e.g. an absolute URL
 * (the external `Admin` link) or a path with no leading slash.
 *
 * The topbar mirrors the AngularJS directive's active logic, which matches the
 * `#(/segment)` portion of a module link against `$location.path()`, so the
 * first path segment is the unit of comparison.
 */
export function getModuleSegment(path: string): string {
  const match = getModuleNavTarget(path).match(/^(\/[^/]+)/)

  return match ? match[1] : ''
}
